import React from 'react';

export function Skeleton({ width, height, borderRadius = 'var(--radius-md)', className = '', style = {} }) {
  return (
    <div
      className={`skeleton ${className}`}
      style={{
        width: width || '100%',
        height: height || '1em',
        borderRadius,
        ...style
      }}
      aria-hidden="true"
    />
  );
}

export function SkeletonCard({ lines = 3 }) {
  return (
    <div className="skeleton-card">
      <Skeleton height={48} borderRadius="var(--radius-md)" style={{ marginBottom: 16 }} />
      <div className="skeleton-card__lines">
        {Array.from({ length: lines }).map((_, i) => (
          <Skeleton key={i} height={16} style={{ marginBottom: i < lines - 1 ? 8 : 0 }} />
        ))}
      </div>
    </div>
  );
}

export function SkeletonStatCard() {
  return (
    <div className="skeleton-stat-card">
      <Skeleton width={60} height={60} borderRadius="var(--radius-md)" />
      <div className="skeleton-stat-card__content">
        <Skeleton width="60%" height={12} style={{ marginBottom: 8 }} />
        <Skeleton width="40%" height={28} />
      </div>
    </div>
  );
}

export function DashboardSkeleton() {
  return (
    <div className="panel-screen">
      <header className="panel-header-bar">
        <div className="panel-header-inner">
          <div className="logo">
            <Skeleton width={40} height={40} borderRadius="8px" />
            <Skeleton width={180} height={24} />
          </div>
          <Skeleton width={120} height={40} borderRadius="var(--radius-full)" />
        </div>
      </header>
      <div className="panel-layout">
        <aside className="panel-sidebar">
          {[1, 2, 3, 4].map(i => (
            <Skeleton key={i} height={44} style={{ marginBottom: 4 }} />
          ))}
        </aside>
        <main className="panel-content">
          <Skeleton height={36} width={200} style={{ marginBottom: 8 }} />
          <Skeleton height={20} width={300} style={{ marginBottom: 32 }} />
          <div className="stats-grid-modern" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 24 }}>
            {[1, 2, 3].map(i => (
              <SkeletonStatCard key={i} />
            ))}
          </div>
        </main>
      </div>
    </div>
  );
}

export function AdminContentSkeleton({ tab = 'dashboard' }) {
  if (tab === 'dashboard') {
    return (
      <>
        <Skeleton height={40} width={180} style={{ marginBottom: 8 }} />
        <Skeleton height={18} width={280} style={{ marginBottom: 32 }} />
        <div className="admin-stats-grid">
          {[1, 2, 3, 4, 5, 6].map(i => (
            <SkeletonStatCard key={i} />
          ))}
        </div>
      </>
    );
  }
  return (
    <>
      <Skeleton height={40} width={180} style={{ marginBottom: 8 }} />
      <Skeleton height={18} width={280} style={{ marginBottom: 32 }} />
      <div className="submissions-list" style={{ gap: 16 }}>
        {[1, 2, 3, 4].map(i => (
          <div key={i} className="skeleton-stat-card" style={{ padding: 24 }}>
            <Skeleton width="30%" height={24} style={{ marginBottom: 12 }} />
            <Skeleton width="60%" height={16} style={{ marginBottom: 8 }} />
            <Skeleton width="80%" height={14} />
          </div>
        ))}
      </div>
    </>
  );
}

export function AdminPanelSkeleton() {
  return (
    <div className="admin-page">
      <header className="admin-header-bar">
        <div className="admin-header-inner">
          <Skeleton width={40} height={40} borderRadius="8px" />
          <Skeleton width={140} height={32} borderRadius="var(--radius-full)" />
        </div>
      </header>
      <div className="admin-layout">
        <aside className="admin-sidebar">
          {[1, 2, 3, 4].map(i => (
            <Skeleton key={i} height={44} style={{ marginBottom: 4 }} />
          ))}
        </aside>
        <div className="admin-content">
          <AdminContentSkeleton />
        </div>
      </div>
    </div>
  );
}
